import { PickerPanel } from "./_picker";
import { ACTION_CATEGORIES } from "./_automation_data";

export default function ActionPicker({ onClose, onPick }) {
  return <PickerPanel title="Actions" testId="action-picker"
    catalog={ACTION_CATEGORIES} onClose={onClose} onPick={onPick} />;
}
